import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './contentResponsibilityPolicyText.scss';

function ContentResponsibilityPolicyText() {
  return (
    <div className={styles.policyText}>
      När du lämnar och publicerar dina personuppgifter här och personuppgifter
      om andra personer, som är i livet, är det viktigt att personerna är
      informerade om och har lämnat sitt uttryckliga godkännande till att
      personuppgifterna inkluderas i publiceringen. Vill du läsa mer om hur
      Hjärt-Lungfonden behandlar personuppgifter, se{' '}
      <ReactLink
        to={'https://www.hjart-lungfonden.se/om-oss/dataskydd/'}
        className={`${styles.policyLink}`}
      >
        dataskyddspolicy
      </ReactLink>
    </div>
  );
}

export default ContentResponsibilityPolicyText;
